import config from "../utils/config";
import http from "../utils/http";
import * as tokenService from "./../services/token";
const fileUploadUrl = `${config.restBaseUrl}/upload`;
export const upload = async (file: any, name: string) => {
  const token = tokenService.getAccessToken();
  const fileName = name.replaceAll("/", " or ");
  return http.post(
    `${fileUploadUrl}?name=${fileName}`,
    { file: file[0] },
    {
      headers: {
        "Content-Type": "multipart/form-data",
        token: token,
      },
    }
  );
};

export const deleteFile = async (url: string) => {
  const token = tokenService.getAccessToken();
  return http.delete(fileUploadUrl, {
    data: { url },
    headers: {
      token: token,
    },
  });
};

const fileUploadService = {
  upload,
  deleteFile,
};

export default fileUploadService;
